import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label"]

  dragOver(e) {
    e.preventDefault()
  }

  dragEnter(e) {
    e.preventDefault()
    this.element.classList.add("drag-over")
  }

  dragLeave(e) {
    if (!this.element.contains(e.relatedTarget)) {
      this.element.classList.remove("drag-over")
    }
  }

  drop(e) {
    e.preventDefault()
    this.element.classList.remove("drag-over")
    const files = e.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
      this.labelTarget.textContent = files[0].name
    }
  }
}
